/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React, { FC, useContext, useEffect } from 'react'
import { Redirect, Switch, Route } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import { PrivateRoutes } from './PrivateRoutes'
import { Logout, AuthPage } from '../modules/auth'
import { ErrorsPage } from '../modules/errors/ErrorsPage'
import { IsAuthorizedContext } from '../contexts/isAuthorizedContext'
// import {RootState} from '../../setup'
import { useAuth } from '../contexts/CustomContextHook/useAuth'
import { array, string } from 'yup/lib/locale'



const Routes = () => {
  // const isAuthorized = useSelector<RootState>(({auth}) => auth.user, shallowEqual)

  // const isAuthorizedCxt = useContext(IsAuthorizedContext);

  const { UserToken } = useAuth()





  useEffect(
    () => {
      console.log('UserRoles- in routes.js-- ', localStorage.getItem('UserRoles'));

      if (localStorage.getItem('UserRoles') !== null) {

        console.log('UserRoles--- ', localStorage.getItem('UserRoles'));


      }

    }, []
  )

  console.log('UserToken in Routes-------', UserToken);


  var Token = localStorage.getItem('Token');
  var Expiry = localStorage.getItem('Expiry');


  const isAuthorized = new Date(Expiry) > new Date() && Token;


  // const isAuthorized = true;

  // console.log('Token from localStorage', Token);

  // console.log('Expiry from localStorage', Expiry);

  // isAuthorizedCxt.isaAuthorized;


  // console.log('isAuthorized  52---', isAuthorized);

  // console.log('result----', new Date(Expiry).toDateString() > new Date().toDateString());

  // console.log('Expiry Date----', new Date(Expiry).toDateString());
  // console.log('current Date---', new Date().toLocaleString());


  return (
    <Switch>
      {!isAuthorized ? (
        /*Render auth page when user at `/auth` and not authorized.*/
        <Route>
          <AuthPage />
        </Route>
      ) : (
        /*Otherwise redirect to root page (`/`)*/
        <Redirect from='/auth' to='/' />
      )}






      <Route path='/error' component={ErrorsPage} />
      <Route path='/logout' component={Logout} />

      {!isAuthorized ? (
        /*Redirect to `/auth` when user is not authorized*/
        <Redirect to='/auth/login' />
      ) : (
        <MasterLayout>
          <PrivateRoutes />
        </MasterLayout>
      )}
    </Switch>
  )
}

export { Routes }
